import slugify from 'slugify';
import {escapeHtml} from '../../Common/escapeHtml';

export const safeSlugify = text => `h-${escapeHtml(slugify(text, {
  remove: /[!"#$%&'\.()*+,\/:;<=>?@\[\]\\^_`{|}~]/g, lower: true,
}))}`;